<template>
  <div class="bss-pager-wrap">
    <el-button icon="layout layout-first"
               class="btn-text"
               type="text"
               :disabled="firstDisabled()"
               @click="goFirst">
    </el-button>
    <el-button icon="layout layout-previous"
               class="btn-text"
               type="text"
               hotkey="ctrl+←"
               :disabled="previousDisabled()"
               @click="goPrevious">
    </el-button>
    <kye-number v-model.number="curPage"
                style="width:40px;"
                :clearable="false"
                :min="1"
                :max="total()"
                :disabled="pageDisabled()"
                @focus="isBlur = false"
                @blur="pageBlur">
    </kye-number>
    <span>/ {{ total() }}</span>
    <el-button icon="layout layout-next"
               class="btn-text"
               type="text"
               hotkey="ctrl+→"
               :disabled="nextDisabled()"
               @click="goNext">
    </el-button>
    <el-button icon="layout layout-last"
               class="btn-text"
               type="text"
               :disabled="lastDisabled()"
               @click="goLast">
    </el-button>
  </div>
</template>

<script>
  export default {
    reportName: 'biz-bss-pager',
    props: {
      value: String,
      data: {
        type: Array,
        default: () => []
      },
      idKey: {
        type: String,
        default: () => 'id'
      },
    },
    data () {
      return {
        isBlur: true,
        curPage: 0
      }
    },
    computed: {
      idList () {
        if (this.data && this.data.length) {
          return this.data.map(item => item[this.idKey])
        }
        return []
       }
    },
    watch: {
      value: {
        handler () {
          this.initData()
        },
        immediate: true,
        deep: true,
      }
    },
    methods: {
      // 初始化数据
      initData () {
        let ids = this.idList
        const index = ids.findIndex(item => item === this.value)
        this.curPage = index > -1 ? index + 1 : 0
      },
      // 最大页数
      total () {
        let ids = this.idList
        if (ids && ids.length) {
          return ids.length
        }
        return 0
      },
      // 禁止输入
      pageDisabled () {
        let ids = this.idList
        return !(ids && ids.length > 0)
      },
      // 禁止 上一页 按钮点击
      previousDisabled () {
        const id = this.value
        const ids = this.idList
        return !this.isBlur || !(ids && ids.indexOf(id) > 0)
      },
      // 禁止 下一页 按钮点击
      nextDisabled () {
        const id = this.value
        const ids = this.idList
        return !this.isBlur || !(ids && ids.includes(id) && ids.indexOf(id) < ids.length - 1)
      },
      // 禁止 前往第一页 按钮点击
      firstDisabled () {
        const id = this.value
        const ids = this.idList
        return !this.isBlur || !(ids && ids.includes(id) && ids[0] !== id)
      },
      // 禁止 前往第最后一页 按钮点击
      lastDisabled () {
        const id = this.value
        const ids = this.idList
        const lastId = ids[ids.length - 1]
        return !this.isBlur || !(ids.includes(id) && lastId !== id)
      },
      // 前往第一页
      goFirst () {
        let id = this.idList[0]
        this.replaceRouter(id, 1)
      },
      // 前往最后一页
      goLast () {
        let ids = this.idList
        let index = ids.length
        let id = ids[index - 1]
        this.replaceRouter(id, index)
      },
      // 上一页
      goPrevious () {
        let ids = this.idList
        let index = ids.indexOf(this.value)
        if (index <= 0) return
        let id = ids[index - 1]
        this.replaceRouter(id, index)
      },
      // 下一页
      goNext () {
        let ids = this.idList
        let index = ids.indexOf(this.value)
        if (index < 0 || index >= ids.length - 1) return
        let id = ids[index + 1]
        let page = index + 2
        this.replaceRouter(id, page)
      },
      // 输入完成 失焦后跳转
      pageBlur () {
        if (typeof this.curPage === 'number' && this.curPage > 0 && this.curPage <= this.total()) {
          let id = this.idList[this.curPage - 1]
          if (id && id !== this.value) {
            this.replaceRouter(id, this.curPage)
          }
        } else {
          this.$message.warning('请输入合适的数字')
        }
        this.isBlur = true
      },
      replaceRouter (id, page) {
        const row = this.data.find(v => v[this.idKey] === id)
        this.curPage = page
        this.$emit('input', id)
        this.$emit('change', row)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .bss-pager-wrap {
    display: inline-block;
    .el-input__inner {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/pages/home/bss-pager/index.vue